import initialState from "./initialState";
import configureAppStore, { history } from "./configureStore";

const store = configureAppStore(initialState);

export { store, history };
